interface LogoMarkProps {
  size?: "sm" | "md" | "lg";
}

export default function LogoMark({ size = "md" }: LogoMarkProps) {
  const heights: Record<string, string> = {
    sm: "h-9",
    md: "h-12",
    lg: "h-16",
  };

  const textSizes: Record<string, { main: string; sub: string }> = {
    sm: { main: "text-xl", sub: "text-[9px]" },
    md: { main: "text-2xl", sub: "text-[10px]" },
    lg: { main: "text-4xl", sub: "text-[12px]" },
  };

  return (
    <div className={`flex items-center ${heights[size]}`}>
      <div className="flex flex-col items-start leading-none">
        {/* Swoosh accent line */}
        <div className="relative flex items-center mb-0.5">
          <div
            className="absolute -top-2 left-0 right-0 h-px"
            style={{
              background: "linear-gradient(90deg, transparent, #00bcd4 30%, #b0e0e6 60%, transparent)",
              transform: "rotate(-2deg)",
              opacity: 0.7,
            }}
          />
        </div>

        {/* Main wordmark */}
        <div
          className={`font-black italic tracking-tight leading-none ${textSizes[size].main}`}
          style={{
            fontFamily: "'Outfit', sans-serif",
            background: "linear-gradient(135deg, #e8f4f8 0%, #00bcd4 35%, #ffffff 55%, #7ecbd6 80%, #4db8cc 100%)",
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
            backgroundClip: "text",
            filter: "drop-shadow(0 1px 3px rgba(0,188,212,0.4))",
            textShadow: "none",
          }}
        >
          eXCLUSIVE
        </div>

        {/* Sub wordmark */}
        <div
          className={`tracking-[0.35em] font-bold ${textSizes[size].sub}`}
          style={{
            fontFamily: "'Outfit', sans-serif",
            color: "#b0d8e0",
            letterSpacing: "0.35em",
            marginTop: "2px",
          }}
        >
          T &nbsp; O &nbsp; W &nbsp; I &nbsp; N &nbsp; G
        </div>

        {/* Bottom swoosh */}
        <div
          className="mt-1 w-full h-px"
          style={{
            background: "linear-gradient(90deg, transparent, #00bcd4 20%, #b0e0e6 70%, transparent)",
            opacity: 0.6,
          }}
        />
      </div>
    </div>
  );
}
